module.exports = __webpack_public_path__ + "img/5-4.d29beda3.png";